import { createContext } from 'react';

import type { Integration } from '../integrations/types';

export interface AnalyticsIntegrationsCtx {
  integrations: Integration[];
}

export default createContext<AnalyticsIntegrationsCtx | undefined>(undefined);
